<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="visible"
    :show-close="false"
    width="588px">
    <div class="base-info-wrap">
      <span class="alert-head">尊敬的客户</span>
      <span class="alert-head" style="text-indent: 2em;margin-top: 5px;">您好！</span>
      <div class="alert-content" v-html="title"></div>
      <div class="alert-foot">
        <span>考网平台服务组</span>
        <span>2022年8月1日</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleSave" :loading="handleLoading">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AccountAlert',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      handleLoading: false,
      dialogTitle: '温馨提示'
    }
  },
  methods: {
    handleSave () {
      if (this.status == 'timeOut') {
        window.document.location.href = location.origin
        // window.document.location.href = 'https://www.kaow.cn'
      } else {
        this.$emit('close')
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.base-info-wrap{
  display: flex;
  height: 320px;
  flex-direction: column;
  position: relative;
  .alert-head{
    color: $color-success;
    font-size: 20px;
    font-weight: bold;
  }
  .alert-content{
    margin-top: 10px;
    font-size: 14px;
    line-height: 2;
  }
  .alert-foot{
    position: absolute;
    bottom: -20px;
    right: 0;
    text-align: right;
    line-height: 2;
    span {
      display: block;
    };
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/AccountAlert.vue